module.exports = "https://r.nearpod.com/assets/media/image/settings-header-icon-679c0559094e0fa81ff505d7699cbd1e.png";